import {
  ElementPropertyRule,
  ElementPropertyRuleRecord,
} from '@fullstory/proto/fs/services/search-settings';
import React from 'react';
import { useElementPropertyRuleSignalStudio } from '../../hooks/useElementPropertyRuleSignalStudio';
import { useFlags } from '@fullstory/react-hooks';
import { useElementPropertyRuleSignalStudioV2 } from '../../hooks/useElementPropertyRuleSignalStudioV2';
import { isV2CompatiblePropertyRule } from '../../utils';

export enum ElementPropertyRuleModalSource {
  settings,
  relatedSettings,
  home,
}

export enum ElementPropertyRuleModalVariant {
  new,
  view,
}

interface ElementPropertyRuleType<T> {
  name?: T;
  any?: T;
  namedElementId?: T;
  selectors?: T;
  anyChild?: T;
  childNamedElementId?: T;
  childSelectors?: T;
  attribute?: T;
  innerText?: T;
  static?: T;
  regex?: { expression?: T; format?: T };
  propertyName?: T;
  propertyType?: T;
}

export type ElementPropertyRuleErrors = ElementPropertyRuleType<string>;

export type ElementPropertyRuleTouched = ElementPropertyRuleType<boolean>;

interface ElementPropertyRuleModalProps {
  elementPropertyRuleRecord: ElementPropertyRuleRecord;
  onSave: (elementPropertyRule: ElementPropertyRule) => void;
  onArchive: (id: string) => void;
  onUnarchive: (id: string) => void;
  onCloseSignal: () => void;
  variant: ElementPropertyRuleModalVariant;
  source: ElementPropertyRuleModalSource;
  sourceElementName?: string;
}

export const ElementPropertyRuleModal: React.FC<ElementPropertyRuleModalProps> = props => {
  const flags = useFlags();

  return flags.featureFlags().AppElementPropertyRulesV2 &&
    isV2CompatiblePropertyRule(props.elementPropertyRuleRecord) ? (
    <ElementPropertyRuleModalSignalStudioImplV2
      data-component="ElementPropertyRuleModal"
      {...props}
    />
  ) : (
    <ElementPropertyRuleModalSignalStudioImpl
      data-component="ElementPropertyRuleModal"
      {...props}
    />
  );
};

const ElementPropertyRuleModalSignalStudioImplV2: React.FC<ElementPropertyRuleModalProps> = ({
  elementPropertyRuleRecord,
  onCloseSignal,
  variant,
  onSave,
  onArchive,
  onUnarchive,
  source,
  sourceElementName,
}) => {
  const { SignalStudio, signalStudioProps } = useElementPropertyRuleSignalStudioV2({
    elementPropertyRuleRecord,
    onCloseSignal,
    variant,
    onSave,
    onArchive,
    onUnarchive,
    source,
    sourceElementName,
  });

  if (!SignalStudio) {
    return null;
  }

  return (
    <SignalStudio
      data-component="ElementPropertyRuleModalSignalStudioImplV2"
      {...signalStudioProps}
    />
  );
};

const ElementPropertyRuleModalSignalStudioImpl: React.FC<ElementPropertyRuleModalProps> = ({
  elementPropertyRuleRecord,
  onCloseSignal,
  variant,
  onSave,
  onArchive,
  onUnarchive,
  source,
}) => {
  const { SignalStudio, signalStudioProps } = useElementPropertyRuleSignalStudio({
    elementPropertyRuleRecord,
    onCloseSignal,
    variant,
    onSave,
    onArchive,
    onUnarchive,
    source,
  });

  if (!SignalStudio) {
    return null;
  }

  return (
    <SignalStudio
      data-component="ElementPropertyRuleModalSignalStudioImpl"
      {...signalStudioProps}
    />
  );
};
